<template>
  <div class="mt-10">
    <div class="bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6">
      <div class="md:grid md:grid-cols-3 md:gap-6">
        <div class="md:col-span-1">
          <h3 class="text-lg font-medium leading-6 text-gray-900">
            Online Store 2.0
          </h3>
          <p class="mt-1 text-sm leading-5 text-gray-500">
            If your theme support App extensions you can use this option to
            enable/disable widgets. Please contact support before you enable .
          </p>
        </div>
        <div class="md:col-span-2">
          <fieldset class="mt-6">
            <legend class="text-base leading-6 font-medium text-gray-900">
              Enable Chat & Share widget in your Online 2.0 theme
            </legend>

            <div class="mt-4 flex flex-wrap">
              <button
                type="button"
                class="inline-flex items-center px-2.5 py-1.5 border border-gray-300 shadow-sm text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                @click="openEmbedLink"
              >
                Open Theme Editor
              </button>
            </div>
          </fieldset>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OnlineStore2Support",

  components: {},
  model: {
    prop: "config",
    event: "change"
  },
  props: {
    config: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  mounted() {},
  data() {
    return {};
  },
  methods: {
    openEmbedLink() {
      this.$store.dispatch("getEmbedUrl").then(response => {
        window.open(response.url, "_blank");
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
